import { IconProps } from '@tajdid/tajdid-ui/icons';

function WhatsAppIcon(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      {...props}
      viewBox="0 0 40 41"
      fill="none"
    >
      <g clipPath="url(#clip0_3345_7809)">
        <path
          d="M20 40.5C31.0457 40.5 40 31.5457 40 20.5C40 9.4543 31.0457 0.5 20 0.5C8.9543 0.5 0 9.4543 0 20.5C0 31.5457 8.9543 40.5 20 40.5Z"
          fill="#29A71A"
        />
        <path
          d="M28.818 11.6818C26.7372 9.58023 23.9738 8.29139 21.0264 8.04778C18.079 7.80417 15.1416 8.62183 12.7439 10.3533C10.3463 12.0847 8.64629 14.616 7.95059 17.4904C7.25488 20.3649 7.60926 23.3934 8.94981 26.0295L7.6339 32.4182C7.62024 32.4818 7.61986 32.5475 7.63276 32.6112C7.64567 32.675 7.67158 32.7354 7.7089 32.7886C7.76356 32.8695 7.84158 32.9317 7.93254 32.9671C8.02351 33.0024 8.12309 33.0091 8.21799 32.9864L14.4794 31.5023C17.1081 32.8089 20.1152 33.1405 22.9655 32.4381C25.8158 31.7356 28.3245 30.0448 30.0452 27.6663C31.7658 25.2878 32.5868 22.376 32.3621 19.4491C32.1374 16.5221 30.8815 13.7698 28.818 11.6818ZM26.8657 27.2636C25.426 28.6993 23.5721 29.647 21.5652 29.9732C19.5583 30.2994 17.4996 29.9876 15.6794 29.0818L14.8066 28.65L10.968 29.5591L10.9794 29.5114L11.7748 25.6477L11.3475 24.8046C10.4174 22.9779 10.0893 20.9037 10.4102 18.8792C10.7311 16.8546 11.6845 14.9836 13.1339 13.5341C14.955 11.7135 17.4247 10.6908 19.9998 10.6908C22.5749 10.6908 25.0446 11.7135 26.8657 13.5341C26.8812 13.5519 26.8979 13.5686 26.9157 13.5841C28.7143 15.4094 29.7183 17.8717 29.709 20.4342C29.6996 22.9967 28.6776 25.4516 26.8657 27.2636Z"
          fill="white"
        />
        <path
          d="M26.5249 24.4296C26.0545 25.1705 25.3113 26.0773 24.3772 26.3023C22.7408 26.6978 20.2295 26.316 17.1045 23.4023L17.0658 23.3682C14.3181 20.8205 13.6045 18.7 13.7772 17.0182C13.8727 16.0637 14.6681 15.2 15.3386 14.6364C15.4446 14.5459 15.5703 14.4815 15.7056 14.4483C15.8409 14.4151 15.9822 14.4141 16.118 14.4452C16.2538 14.4763 16.3805 14.5388 16.4879 14.6277C16.5952 14.7165 16.6803 14.8293 16.7363 14.9569L17.7477 17.2296C17.8134 17.377 17.8377 17.5394 17.8181 17.6996C17.7985 17.8597 17.7356 18.0115 17.6363 18.1387L17.1249 18.8023C17.0152 18.9393 16.949 19.1061 16.9348 19.281C16.9206 19.456 16.9592 19.6312 17.0454 19.7841C17.3317 20.2864 18.0181 21.025 18.7795 21.7091C19.634 22.4819 20.5817 23.1887 21.1817 23.4296C21.3423 23.4952 21.5188 23.5112 21.6885 23.4755C21.8583 23.4399 22.0134 23.3542 22.134 23.2296L22.7272 22.6319C22.8417 22.519 22.984 22.4385 23.1397 22.3986C23.2954 22.3587 23.4589 22.3607 23.6136 22.4046L26.0158 23.0864C26.1484 23.1271 26.2698 23.1975 26.3709 23.2923C26.4721 23.3871 26.5502 23.5037 26.5993 23.6333C26.6484 23.7629 26.6673 23.9021 26.6544 24.0401C26.6415 24.1781 26.5972 24.3113 26.5249 24.4296Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3345_7809">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default WhatsAppIcon;
